























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";

import VueRouter, { Location } from "vue-router";
import { Validator } from "vee-validate";
import PartnerCustomization from "@/admin/components/partners/PartnerCustomization.vue";
import PartnerAccountsMigration from "@/admin/components/partners/PartnerAccountsMigration.vue";
import PartnerSettingsNavigation from "@/admin/components/partners/PartnerSettingsNavigation.vue";
import PartnerTheme from "@/admin/components/partners/PartnerTheme.vue";
import PartnerCardSettings from "@/admin/components/partners/PartnerCardSettings.vue";
import { UserPermission } from "@/shared/types";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { usePartnerStore } from "@/admin/store/partner";


@Component ({
    components: {
      PartnerCustomization,
      PartnerSettingsNavigation,
      PartnerTheme,
      PartnerAccountsMigration,
      PartnerCardSettings,
    }
  })
export default class PartnerSettingsPage extends Vue {
  $router: VueRouter;
  $validator: Validator;

  rolePermissions = useRolePermissionsStore();
  partnerStore = usePartnerStore();

  @Prop() partnerId: string;
  @Prop() activeTab: string;
  @Prop() navigate: (args: { tabName: string } ) => Location;

  @Prop() routeToPartnerList: () => Location;

  created (): void {
    this.partnerStore.reload();
  }

  get hasEditPermission (): boolean {
    return this.rolePermissions.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit);
  }

  get partnerName (): string {
    return this.partnerStore.partnerName(this.partnerId);
  }

  get hasViewPermission (): boolean {
    return this.rolePermissions.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit) ||
           this.rolePermissions.userHasAdminPermission(UserPermission.AdminPortalPartnerView);
  }
}
